/* Product gallery (desktop): clicking one of the smaller images swaps it into the big 16:9 spot at the top. */
(function () {
  'use strict';
  if (window.__llGallery) return;
  window.__llGallery = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const BIG = '(min-width: 990px) 58vw, 90vw';
  const SMALL = '(min-width: 990px) 29vw, 90vw';

  function prepare(gallery) {
    Array.from(gallery.children).forEach((m, i) => {
      if (!m.classList.contains('media')) return;
      if (i > 0 && !m.querySelector('video, iframe, model-viewer')) {
        m.setAttribute('tabindex', '0');
        m.setAttribute('role', 'button');
        m.setAttribute('aria-label', 'Show this image larger');
      } else {
        m.removeAttribute('tabindex'); m.removeAttribute('role'); m.removeAttribute('aria-label');
      }
    });
  }

  function promote(media) {
    const gallery = media.parentElement;
    const first = gallery.firstElementChild;
    if (!first || media === first) return;
    // Swap places: the clicked image goes to the top, the old top image takes its spot.
    const marker = document.createComment('');
    gallery.replaceChild(marker, media);
    gallery.insertBefore(media, first);
    gallery.replaceChild(first, marker);
    // Ask for a sharper version now that the image is shown big.
    const bigImg = media.querySelector('img');
    if (bigImg) { bigImg.loading = 'eager'; bigImg.sizes = BIG; }
    const smallImg = first.querySelector('img');
    if (smallImg) smallImg.sizes = SMALL;
    prepare(gallery);
    if (media.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      media.animate([{ opacity: 0, transform: 'scale(.985)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'ease-out' });
      first.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out' });
    }
    // Bring the showcase into view if it has scrolled off the top.
    const top = gallery.getBoundingClientRect().top;
    if (top < 0) window.scrollBy({ top: top - 100, behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    if (!desktop.matches) return;
    const media = e.target.closest('.product__gallery .media');
    if (!media || media === media.parentElement.firstElementChild) return;
    if (e.target.closest('video, iframe, model-viewer, button, a')) return;
    promote(media);
  });
  document.addEventListener('keydown', (e) => {
    if (!desktop.matches || (e.key !== 'Enter' && e.key !== ' ')) return;
    const media = e.target.closest && e.target.closest('.product__gallery .media[role="button"]');
    if (!media) return;
    e.preventDefault();
    promote(media);
    media.focus();
  });
  const init = () => document.querySelectorAll('.product__gallery').forEach((g) => {
    prepare(g);
    if (g._llObserved) return;
    g._llObserved = true;
    // Picking a color moves that color's photo to the top too: keep it sharp and keep the thumbnails clickable.
    new MutationObserver(() => {
      const top = g.firstElementChild && g.firstElementChild.querySelector('img');
      if (top && top.sizes !== BIG) { top.loading = 'eager'; top.sizes = BIG; }
      prepare(g);
    }).observe(g, { childList: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
